// reducers/contentReducer.js
import { FETCH_CONTENT_REQUEST, FETCH_CONTENT_SUCCESS, FETCH_CONTENT_FAILURE } from '../../../Constants/actionTypes';

const initialState = {
    loading: false,
    content: [],
    error: null
};

const contentReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CONTENT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_CONTENT_SUCCESS:
            return {
                ...state,
                loading: false,
                content: action.payload.content,
                error: null
            };
        case FETCH_CONTENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default contentReducer;
